module.exports = __webpack_public_path__ + "img/white.17aff607.png";